import * as Yup from 'yup';

export const EditValidationSchema = (pageType) =>
  Yup.object({
    id: Yup.number().typeError('ID must be a number').required('ID is required'),

    name: Yup.string().trim().required('Name is required'),

    ...(pageType === 'bonus'
      ? {
          bonus: Yup.number()
            .typeError('Bonus must be a number')
            .required('Bonus is required')
            .min(0, 'Bonus cannot be negative'),
        }
      : {
          salary: Yup.number()
            .typeError('Salary must be a number')
            .required('Salary is required')
            .min(0, 'Salary cannot be negative'),
        }),
  });
